module.exports = __webpack_public_path__ + "static/media/bg-header.ade47c44.png";